// CAD files are optional page content and must never hold the phase-data spinner.
export const PHASE_CAD_REQUEST_TIMEOUT_MS = 180000;

export function phaseDetailParams(url, params, headers, options = {}) {
    if (options.deferPhaseCad && /^\/?av\/fase\/[^/]+\/[^/]+\/$/.test(url)) {
        return { ...params, defer_cad: "1" };
    }
    return params;
}

export function createPhaseCadLoader({ request, state, apply }) {
    let key = "", generation = 0, controller = null, pending = null;
    function cancel() {
        generation++;
        controller?.abort();
        controller = null;
        pending = null;
        Object.assign(state, { loading: false, error: "" });
    }
    function select(ordine, operazione) {
        const next = JSON.stringify([String(ordine), Number(operazione)]);
        if (next !== key) { cancel(); key = next; }
    }
    function load(ordine, operazione) {
        select(ordine, operazione);
        if (pending) return pending;
        const current = ++generation;
        controller = new AbortController();
        const signalController = controller;
        Object.assign(state, { loading: true, error: "" });
        pending = (async () => {
            try {
                const response = await request(ordine, operazione, signalController);
                if (current !== generation || signalController.signal.aborted) return;
                const data = response?.data;
                if (!data || String(data.ordine) !== String(ordine) || Number(data.operazione) !== Number(operazione)
                    || !Array.isArray(data.dxfs_piegatura) || !Array.isArray(data.programmi_svg)) {
                    throw new Error("Invalid CAD response");
                }
                apply(data);
                if (Object.keys(data.errors || {}).length) {
                    state.error = "Alcuni file CAD non sono disponibili. Puoi riprovare il caricamento.";
                }
            } catch (_) {
                if (current === generation && !signalController.signal.aborted) {
                    state.error = "File CAD non disponibili. Puoi riprovare il caricamento.";
                }
            } finally {
                if (current === generation) { state.loading = false; pending = null; controller = null; }
            }
        })();
        return pending;
    }
    return { select, load, cancel };
}
